
import React, { useEffect, useRef, useState } from 'react';

const MatrixBackground: React.FC = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [glitchActive, setGlitchActive] = useState(false);

  useEffect(() => {
    if (!containerRef.current) return;
    
    const characters = 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヲン01010101';
    const columns = Math.floor(window.innerWidth / 20);
    
    // Clear any existing elements
    if (containerRef.current.children.length > 0) {
      containerRef.current.innerHTML = '';
    }
    
    // Create matrix columns
    for (let i = 0; i < columns; i++) {
      const column = document.createElement('div');
      column.className = 'matrix-column';
      column.style.left = `${i * 20}px`;
      column.style.animationDelay = `${Math.random() * 5}s`;
      
      const columnHeight = Math.floor(Math.random() * 20) + 15;
      for (let j = 0; j < columnHeight; j++) {
        const char = document.createElement('div');
        char.textContent = characters.charAt(Math.floor(Math.random() * characters.length));
        char.style.opacity = (j === 0) ? '1' : `${Math.random() * 0.5 + 0.5}`;
        char.style.animationDelay = `${Math.random() * 2}s`;
        column.appendChild(char);
      }
      
      containerRef.current.appendChild(column);
    }
    
    // Random glitch effect
    const glitchInterval = setInterval(() => {
      setGlitchActive(true);
      setTimeout(() => setGlitchActive(false), 200);
    }, Math.random() * 5000 + 2000);
    
    // Handle window resize
    const handleResize = () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
        const newColumns = Math.floor(window.innerWidth / 20);
        
        for (let i = 0; i < newColumns; i++) {
          const column = document.createElement('div');
          column.className = 'matrix-column';
          column.style.left = `${i * 20}px`;
          column.style.animationDelay = `${Math.random() * 5}s`;
          
          const columnHeight = Math.floor(Math.random() * 20) + 15;
          for (let j = 0; j < columnHeight; j++) {
            const char = document.createElement('div');
            char.textContent = characters.charAt(Math.floor(Math.random() * characters.length));
            char.style.opacity = (j === 0) ? '1' : `${Math.random() * 0.5 + 0.5}`;
            char.style.animationDelay = `${Math.random() * 2}s`;
            column.appendChild(char);
          }
          
          containerRef.current.appendChild(column);
        }
      }
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      window.removeEventListener('resize', handleResize);
      clearInterval(glitchInterval);
    };
  }, []);
  
  return (
    <div className={`matrix-container ${glitchActive ? 'matrix-glitch' : ''}`} ref={containerRef}>
      <div className="glitch-overlay"></div>
    </div>
  );
};

export default MatrixBackground;
